import React, { useEffect, useState, useRef } from 'react';
import { gsap } from 'gsap';
import { Button } from 'react-bootstrap';
import { AiFillFire, AiOutlineClose } from "react-icons/ai";
import ITServiceDescriptions from '../data/ITServiceDescriptions.js';
import { HashLink } from 'react-router-hash-link';
import '../styles/styles.css'; // Updated CSS file


const services = [
  // Add your services here
  { title: 'Technology Audit', description: "A detailed inspection and report on your company's tech stack.", icon: 'tech_audit.svg' },
  { title: 'System Simplification', description: "We'll help you reduce third-party technology dependencies and create custom solutions to save overhead costs.", icon: 'system_simplification.svg' }
];

const ITConsulting = () => {
  const [selectedService, setSelectedService] = useState(null);
  const [icons, setIcons] = useState({});
  const overlayRef = useRef(null);

  const openOverlay = (service) => {
    setSelectedService(service);
  };

  const closeOverlay = () => {
    setSelectedService(null);
  };

  const handleContactClick = () => {
    closeOverlay();
    // Delay the navigation to give time for the overlay to close
    setTimeout(() => {
      window.location.hash = 'services#contact';
    }, 300);
  };

  const getDetailedDescription = (title) => {
    return ITServiceDescriptions.find(desc => desc.title === title);
  };

  useEffect(() => {
    const loadIcons = async () => {
      const loadedIcons = {};
      for (const service of services) {
        loadedIcons[service.icon] = (await import(`../assets/img/icons/${service.icon}`)).default;
      }
      setIcons(loadedIcons);
    };

    loadIcons();
  }, []);

  useEffect(() => {
    const checkIfClickedOutside = (e) => {
      // If the overlay is open and the clicked target is not within the overlay-content
      if (selectedService && overlayRef.current && !overlayRef.current.contains(e.target)) {
        closeOverlay();
      }
    }

    document.addEventListener("mousedown", checkIfClickedOutside);
    
    return () => {
      // Cleanup the event listener
      document.removeEventListener("mousedown", checkIfClickedOutside);
    }
  }, [selectedService]); // Only re-run if selectedService changes

  return (
    <div style={{paddingTop: '5rem'}}>
      <h1 className="text-center">Internet Technology</h1>
      <div className="it-services-grid-container">
        {services.map((service, index) => (
          <div 
            className="it-services-grid-card" 
            key={index}
            onClick={() => openOverlay(service)}
          >
            {icons[service.icon] && <img src={icons[service.icon]} className='card-img-custom' alt={`${service.title} Icon`} />}  
            <h3>{service.title}</h3>
            <p>{service.description}</p>
          </div>
        ))}
      </div>
      {selectedService && (
        <div className="overlay">
          <div className="overlay-content" ref={overlayRef}>
            <AiOutlineClose className="overlay-close" onClick={closeOverlay} />
            <div className="overlay-box">
              <h2>{selectedService.title}</h2>
              {getDetailedDescription(selectedService.title).paragraphs.map((para, index) => (
                <p key={index}>{para}</p>
              ))}
              <HashLink to="/services#contact" style={{ textDecoration: 'none'}}>
              <Button 
                className='btn-elegant'
                onClick={handleContactClick}
                >
                  Contact Us
                </Button>
            </HashLink>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ITConsulting;
